<template>
  <div>
    <!-- worker -->
    <p class="float-left mt-2">Choose image from your hard drive</p>
    <input
      type="file"
      name="image"
      accept="image/*"
      style="font-size: 1em; padding: 10px 0;"
      @change="setImage"
    />
    <!-- hidden -->
    <div class="d-block">
      <input
        v-if="false"
        type="file"
        multiple
        accept="image/jpeg"
        @change="detectFiles($event.target.files)"
      />
      <span
        v-if="isProgressBarVisible"
        class="progress-bar"
        :style="{ width: progressUpload + '%'}"
      ></span>
    </div>
    <!-- hidden -->

    <div class="upload-image" v-if="isUploadImageVisible">
      <img v-if="false" v-bind:src="imgurl" />

      <div
        style="width: 170px; height:170px; display: block;   margin-right: 20px; "
        v-if="isCropImageBtnVisible"
      >
        <vue-cropper
          ref="cropper"
          :guides="true"
          :view-mode="0"
          drag-mode="crop"
          :auto-crop-area="1"
          :min-container-width="170"
          :min-container-height="170"
          :background="false"
          :rotatable="true"
          :fixed="true"
          :src="imgurl"
          :aspectRatio="1/1"
          :initialAspectRatio="1/1"
          alt="Source Image"
          :img-style="{ 'width': '100px', 'height': '100px' }"
        ></vue-cropper>
      </div>

      <img
        :src="cropImg"
        style="width: 170px; height: 170px;"
        class="cropImage"
        v-if="isCropImageVisible"
      />

      <div class="h-100 d-flex">
        <mdb-btn
          @click="cropImage"
          v-if="isCropImageBtnVisible"
          color="primary"
          class="ml-3 outline float-right btn-ssm"
          rounded
        >Crop image</mdb-btn>
        <!--<button @click="rotate" v-if="imgurl != ''">Rotate</button>-->
        <mdb-btn
          @click="mthUpload"
          v-if="isUploadImageBtnVisible"
          color="primary"
          class="ml-3 outline float-right btn-ssm"
          rounded
        >Upload image</mdb-btn>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "../Firebase";
import { store } from "../store";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import { mdbBtn } from "mdbvue";

export default {
  props: ["nickname"],
  data() {
    return {
      progressUpload: 0,
      file: File,
      uploadTask: "",
      imgurl: "",
      cropImg: "",
      isUploadImageVisible: false,
      isCropImageVisible: false,
      isCropImageBtnVisible: true,
      isUploadImageBtnVisible: false,
      isProgressBarVisible: false
    };
  },
  created: function() {
    //console.log(store.getters.getUser.email);
    //this.$log.success('ProfileAvatarFirebaseStorage created, a beg thing', 'as I said - a big')

    var userProfileDocRef = firebase
      .firestore()
      .collection("usersProfiles")
      .doc(store.getters.getUser.email)
      .get()
      .then(doc => {
        if (!doc.exists) {
          //error!
          //this.imgurl = doc.avatarURL
        } else {
          if (
            doc.data().profilePersonalInfo.avatarUrl !== undefined &&
            doc.data().profilePersonalInfo.avatarUrl !== ""
          ) {
            /*             console.log(
              "UploadAvatar: setting imgurl to " +
                doc.data().profilePersonalInfo.avatarUrl
            ); */
            this.imgurl = doc.data().profilePersonalInfo.avatarUrl;
            this.$emit("url", downloadURL);
          }
        }
      })
      .catch(err => {
        //console.log("error - ", err);
      });
  },
  methods: {
    setImage(e) {
      this.file = e.target.files[0];
      //console.log("---setImage fired, file is: ");
      //console.log(this.file);

      if (!this.file.type.includes("image/")) {
        alert("Please select an image file");
        return;
      }
      if (typeof FileReader === "function") {
        const reader = new FileReader();
        reader.onload = event => {
          this.imgurl = event.target.result;
          // rebuild cropperjs with the updated source
          this.$refs.cropper.replace(event.target.result);
        };
        reader.readAsDataURL(this.file);
        this.isUploadImageVisible = true;
      } else {
        alert("Sorry, FileReader API not supported");
      }
    },
    cropImage() {
      //console.log("---cropImage fired");

      this.isCropImageVisible = true;
      this.isCropImageBtnVisible = false;
      this.isUploadImageBtnVisible = true;

      // get image data for post processing, e.g. upload or setting image src
      this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
    },
    rotate() {
      //console.log("---rotate fired");

      // guess what this does :)
      this.$refs.cropper.rotate(90);
    },
    detectFiles(fileList) {
      //console.log("---detectFiles fired");

      Array.from(Array(fileList.length).keys()).map(x => {
        this.mthUpload(fileList[x]);
      });
    },
    b64toBlob(dataURI) {
      var byteString = atob(dataURI.split(",")[1]);
      var ab = new ArrayBuffer(byteString.length);
      var ia = new Uint8Array(ab);

      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ab], { type: "image/jpeg" });
    },
    mthUpload() {
      this.isProgressBarVisible = true;
      //var fileurl = this.imgurl;
      // //console.log(this.file); //at this stage, file is base64 encoded
      //console.log("%c---upload fired, file is ", "color:green;font:bold;");
      //console.log(this.file);

      if (this.cropImg == "") {
        //SCENARIO 1: user not cropped, not rotated - upload original
        //console.log("%cscenario 1 - cropimg is empty", "color: green");

        this.uploadTask = firebase
          .storage()
          .ref("avatars/" + this.getUser + "/" + this.file.name)
          .put(this.file);
      } else {
        //SCENARIO 2: cropped, converting to blob then upload
        //console.log("%cscenario 2 - cropimg not empty", "color: orange");
        //console.log(this.cropImg);

        let cropImgBlob = this.b64toBlob(this.cropImg);

        this.uploadTask = firebase
          .storage()
          .ref("avatars/" + this.getUser + "/" + this.file.name)
          .put(cropImgBlob);
      }
    }
  },
  computed: {
    getUser: function() {
      var uuid = store.getters.getUser.uid; //photoURL
      //console.log(uuid);
      return uuid ? uuid : "null";
    }
  },
  watch: {
    uploadTask: function() {
      //console.log("---UploadAvatar uploadTask");

      this.uploadTask.on(
        "state_changed",
        sp => {
          this.progressUpload = Math.floor(
            (sp.bytesTransferred / sp.totalBytes) * 100
          );
        },
        null,
        () => {
          this.uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
            this.$emit("url", downloadURL);
            this.imgurl = downloadURL;
            store.commit("setAvatarurl", this.imgurl);

            var profilePersonalInfo = {
              nickname: this.nickname,
              avatarUrl: downloadURL
            };

            firebase
              .firestore()
              .collection("usersProfiles")
              .doc(store.getters.getUser.email)
              .update({
                profilePersonalInfo: profilePersonalInfo
              });
          });
        }
      );
    }
  },
  components: {
    VueCropper,
    mdbBtn
  }
};
</script>

<style>
.progress-bar {
  margin: 10px 0;
}
</style>
